export default "__VITE_ASSET__BEU1g9e5__"